import { render, staticRenderFns } from "./LsvaOverviewView.vue?vue&type=template&id=54072916&scoped=true&"
import script from "./LsvaOverviewView.vue?vue&type=script&lang=js&"
export * from "./LsvaOverviewView.vue?vue&type=script&lang=js&"
import style0 from "./LsvaOverviewView.vue?vue&type=style&index=0&id=54072916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54072916",
  null
  
)

/* custom blocks */
import block0 from "./LsvaOverviewView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports